"use strict";

exports.__esModule = true;
exports.SectionLabelFields = SectionLabelFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactDebounceInput = require("react-debounce-input");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for SectionLabelElement.
 */
function SectionLabelFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("SectionLabelFields.content.label", "Label Content")
    }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
      element: _core.InputGroup,
      minLength: 2,
      debounceTimeout: 300,
      value: element.props.content || "",
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "content", e.target.value);
      }
    }));
  });
}